import banners from "../mell/tooltip-images/banners.png"
import games_row from "../mell/tooltip-images/games_row.png"
import profile from "../mell/tooltip-images/profile.png"
import providers_slider from "../mell/tooltip-images/providers_slider.png"

const tooltipImages = {
  banners,
  games_row,
  profile,
  providers_slider,
  profile_button: profile,
}

export { tooltipImages }
